import { render, staticRenderFns } from "./expected_student_files.vue?vue&type=template&id=6b7fbf3c&scoped=true&"
import script from "./expected_student_files.vue?vue&type=script&lang=ts&"
export * from "./expected_student_files.vue?vue&type=script&lang=ts&"
import style0 from "./expected_student_files.vue?vue&type=style&index=0&id=6b7fbf3c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7fbf3c",
  null
  
)

export default component.exports